import schema from '../../../assets/formSchemas/formDataSchema.json'
import formFields from '../../../assets/formSchemas/formFields.json'

export default {
  LOGIN (state, payload) {
    state.token = payload
    state.loggedIn = true
  },
  LOGOUT (state, payload) {
    state.loggedIn = false
    state.token = null
    state.myInfo = null
  },
  PASSWORD_RESET (state, payload) {
    state.passwordReset = true
  },
  RESETPASSWORDERROR(state, payload) {
    state.passwordReset = false
  },
  LOGINFIELDSET (state, payload) {
    const fieldset = formFields.login
    const loginProperties = schema['OAuth2.Login'].properties
    let retArray = []

    fieldset.forEach(function (field) {
      if (loginProperties.hasOwnProperty(field.name)) {
        retArray.push(Object.assign({}, field, loginProperties[field.name]))
      }
    })

    state.loginSchema = retArray
  },
  REFRESH (state, payload) {
    state.loggedIn = true
    state.token = payload
  },
  FORGOTPASSWORDFIELDSET (state, payload) {
    const fieldset = formFields.requestPassword
    const requestPasswordProperties = schema['OAuth2.PasswordRequest'].properties
    let retArray = []

    fieldset.forEach(function (field) {
      if (requestPasswordProperties.hasOwnProperty(field.name)) {
        retArray.push(Object.assign({}, field, requestPasswordProperties[field.name]))
      }
    })

    state.forgotPasswordSchema = retArray
  },
  RESETPASSWORDFIELDSET (state, payload) {
    const fieldset = formFields.resetPassword
    const resetPasswordProperties = schema['OAuth2.PasswordReset'].properties
    let retArray = []

    fieldset.forEach(function (field) {
      if (resetPasswordProperties.hasOwnProperty(field.name)) {
        retArray.push(Object.assign({}, field, resetPasswordProperties[field.name]))
      }
    })
    state.resetPasswordSchema = retArray
  }
}



// WEBPACK FOOTER //
// ./src/app/store/login/mutations.js